import React from 'react';
import {FaTasks} from "react-icons/fa";
import {MdAccessTime} from "react-icons/md";
import {ProgressBar} from "../ProgressBar";
import {getInterpolatedColor, score_palette} from "../color/Palettes";
import {Link} from "react-router-dom";
import ImageContent from "../../routes/course/ImageContent";

export function QuizThumbnail({name, questionCount, highscore}) {

    return (
        <div className={"d-flex flex-column align-items-center p-3 py-4 shadow bg-white rounded border"}
             style={{fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"}}>
            <h4 className={"fw-bold text-center"} style={{fontSize: "100%"}}>{name}</h4>

            <div>
                <label className={"fs-5"}>Antall spørsmål: {questionCount} oppgaver</label>
            </div>

            <div>
                <label className={"fs-5"}>Estimert tid: {Math.round(questionCount * 10 / 60)} min</label>
            </div>


            <div className={"w-50 my-3"}>
                <ProgressBar progress={(highscore ?? 0)} height={30}
                             color={getInterpolatedColor(score_palette, highscore, 0, 100)}/>
            </div>

            <Link to={name} className={"btn btn-primary text-decoration-none text-white py-2 px-3 "}>
                Start quiz
            </Link>

        </div>
    );
}